'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_iltotore_iron_package$package$() {
}
export { $c_Lio_github_iltotore_iron_package$package$ as $c_Lio_github_iltotore_iron_package$package$ };
$p = $c_Lio_github_iltotore_iron_package$package$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lio_github_iltotore_iron_package$package$;
/** @constructor */
function $h_Lio_github_iltotore_iron_package$package$() {
}
export { $h_Lio_github_iltotore_iron_package$package$ as $h_Lio_github_iltotore_iron_package$package$ };
$h_Lio_github_iltotore_iron_package$package$.prototype = $p;
$p.PV = (function(value, constraint) {
  if ((!(!constraint.zs.j(value)))) {
    return value;
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), constraint.zt);
  }
});
var $d_Lio_github_iltotore_iron_package$package$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_iltotore_iron_package$package$, "io.github.iltotore.iron.package$package$", ({
  jy: 1
}));
export { $d_Lio_github_iltotore_iron_package$package$ as $d_Lio_github_iltotore_iron_package$package$ };
var $n_Lio_github_iltotore_iron_package$package$;
function $m_Lio_github_iltotore_iron_package$package$() {
  if ((!$n_Lio_github_iltotore_iron_package$package$)) {
    $n_Lio_github_iltotore_iron_package$package$ = new $c_Lio_github_iltotore_iron_package$package$();
  }
  return $n_Lio_github_iltotore_iron_package$package$;
}
export { $m_Lio_github_iltotore_iron_package$package$ as $m_Lio_github_iltotore_iron_package$package$ };
